/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetMktuList200ResponseDataMktuListInner } from './GetMktuList200ResponseDataMktuListInner'
import {
  GetMktuList200ResponseDataMktuListInnerFromJSON,
  GetMktuList200ResponseDataMktuListInnerFromJSONTyped,
  GetMktuList200ResponseDataMktuListInnerToJSON,
} from './GetMktuList200ResponseDataMktuListInner'

/**
 *
 * @export
 * @interface GetMktuList200ResponseData
 */
export interface GetMktuList200ResponseData {
  /**
   * Выбранные классы МКТУ
   * @type {Array<GetMktuList200ResponseDataMktuListInner>}
   * @memberof GetMktuList200ResponseData
   */
  mktuList: Array<GetMktuList200ResponseDataMktuListInner>
}

/**
 * Check if a given object implements the GetMktuList200ResponseData interface.
 */
export function instanceOfGetMktuList200ResponseData(
  value: object
): value is GetMktuList200ResponseData {
  if (!('mktuList' in value) || value['mktuList'] === undefined) return false
  return true
}

export function GetMktuList200ResponseDataFromJSON(
  json: any
): GetMktuList200ResponseData {
  return GetMktuList200ResponseDataFromJSONTyped(json, false)
}

export function GetMktuList200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetMktuList200ResponseData {
  if (json == null) {
    return json
  }
  return {
    mktuList: (json['mktuList'] as Array<any>).map(
      GetMktuList200ResponseDataMktuListInnerFromJSON
    ),
  }
}

export function GetMktuList200ResponseDataToJSON(
  value?: GetMktuList200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    mktuList: (value['mktuList'] as Array<any>).map(
      GetMktuList200ResponseDataMktuListInnerToJSON
    ),
  }
}
